import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from 'react-share';
import config from '../../config';
import { IconSocialMediaX } from '../../components';

import css from './ShareModal.module.css';

const SHARE_ICON_SIZE = 20;

const ShareButtons = props => {
  const { location } = props;
  const intl = useIntl();
  // react-share names each button after its network in English ("twitter"); use our labels
  const label = id => ({ 'aria-label': intl.formatMessage({ id }) });

  // react-share button props
  const reactShareButtonProps = {
    className: css.shareButton,
    url: `${config.canonicalRootURL}${location.pathname}`,
    resetButtonStyle: false,
  };

  // react-share icon props
  const reactShareIconProps = {
    className: css.shareIcon,
    size: SHARE_ICON_SIZE,
    round: true,
  };

  // Share buttons
  const facebookButton = (
    <FacebookShareButton {...reactShareButtonProps} {...label('ShareModal.shareFacebook')}>
      <FacebookIcon {...reactShareIconProps} />
      <FormattedMessage id="ShareModal.shareFacebook" />
    </FacebookShareButton>
  );
  const twitterButton = (
    <TwitterShareButton {...reactShareButtonProps} {...label('ShareModal.shareX')}>
      {/* react-share 4 only has the old bird; X in the same round badge as the others */}
      <span className={css.shareIconX}>
        <IconSocialMediaX rootClassName={css.shareIconXLogo} />
      </span>
      <FormattedMessage id="ShareModal.shareX" />
    </TwitterShareButton>
  );
  const whatsappButton = (
    <WhatsappShareButton {...reactShareButtonProps} {...label('ShareModal.shareWhatsapp')}>
      <WhatsappIcon {...reactShareIconProps} />
      <FormattedMessage id="ShareModal.shareWhatsapp" />
    </WhatsappShareButton>
  );
  const emailButton = (
    <EmailShareButton {...reactShareButtonProps} {...label('ShareModal.shareEmail')}>
      <EmailIcon {...reactShareIconProps} />
      <FormattedMessage id="ShareModal.shareEmail" />
    </EmailShareButton>
  );
  return (
    <div className={css.shareButtons}>
      {facebookButton}
      {twitterButton}
      {whatsappButton}
      {emailButton}
    </div>
  );
};

export default ShareButtons;
